import type { FC } from "react";
import { abbrNumberFilter } from "app/filters/ngFilters";
import { RangeFixedValues } from "@similarweb/ui-components";
import { getCommonIntervals } from "../../filters/AllRangeGenericFilters/fixedValues";
import type { INumberRange } from "app/UtilitiesAndConstants/types/range";

interface INumberRangeProps {
    filterValue: INumberRange;
    textKey: string;
    onChange: (stepValue: INumberRange) => void;
    min?: number;
    max?: number;
    fixedValues?: Array<number>;
}
export const NumberRange: FC<INumberRangeProps> = (props) => {
    const { filterValue = {}, textKey, onChange, min = 0, max = 30, fixedValues = getCommonIntervals() } = props;

    const numberFormatter = (num) => abbrNumberFilter()(num);

    const getDescription = (filterValue, max, min) => {
        const isTopRangeOnMax: boolean = filterValue.to === max;
        const isBottomRangeOnMax: boolean = filterValue.from === max;
        const isTopRangeOnMin: boolean = filterValue.to === min;
        const isBottomRangeOnMin: boolean = filterValue.from === min;
        const formattedFrom = numberFormatter(filterValue.from);
        const formattedTo = numberFormatter(filterValue.to);

        if (isTopRangeOnMax && isBottomRangeOnMax) {
            return numberFormatter(max);
        } else if (isTopRangeOnMin && isBottomRangeOnMin) {
            return numberFormatter(min);
        } else if (isBottomRangeOnMin && !isTopRangeOnMax) {
            return `Less than ${formattedTo}`;
        } else if (isTopRangeOnMax) {
            return `${formattedFrom}-∞`;
        } else {
            return `${formattedFrom}-${formattedTo}`;
        }
    };
    return (
        <RangeFixedValues
            title={textKey}
            pushable={1}
            value={Object.values(filterValue)}
            allowCross={false}
            onChange={(stepValue) => {
                const value = { from: stepValue[0], to: stepValue[1] };
                onChange(value);
            }}
            fixedValues={fixedValues}
            description={getDescription(filterValue, max, min)}
        />
    );
};
